import React from "react";
import FormSection from "../components/sections/FormSection";

export const ContactUsView = () => (
    <FormSection />
);
